import type { ComponentMeta } from "@mijalowcode/types";
import { ComponentCategory, PropType } from "@mijalowcode/types";

export const AlertMeta: ComponentMeta = {
  componentName: "Alert",
  package: "@mijadesign/web",
  title: "警告提示",
  description: "用于展示重要的提示信息",
  category: ComponentCategory.FEEDBACK,
  icon: "WarningOutlined",
  canHaveChildren: false,
  props: [
    {
      name: "message",
      label: "提示信息",
      type: PropType.STRING,
      group: "基础",
    },
    {
      name: "description",
      label: "详细描述",
      type: PropType.STRING,
      group: "基础",
    },
    {
      name: "type",
      label: "类型",
      type: PropType.ENUM,
      defaultValue: "info",
      options: [
        { label: "成功", value: "success" },
        { label: "信息", value: "info" },
        { label: "警告", value: "warning" },
        { label: "错误", value: "error" },
      ],
      group: "样式",
    },
    {
      name: "closable",
      label: "可关闭",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "功能",
    },
    {
      name: "showIcon",
      label: "显示图标",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "样式",
    },
  ],
  defaultProps: {
    message: "提示信息",
    type: "info",
  },
  npm: {
    package: "@mijadesign/web",
    exportName: "Alert",
  },
  snippet: {
    componentName: "Alert",
    package: "@mijadesign/web",
    props: { message: "提示信息", type: "info" },
  },
};
